export var Notifications = {
    service: null,
};



//////////////////
// WEBPACK FOOTER
// ./src/services/notifications.ts
// module id = 486
// module chunks = 1